var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.512 9.88135C2.53915 9.88135 0 10.3916 0 12.431C0 14.4721 2.523 14.9999 5.512 14.9999C8.48485 14.9999 11.024 14.4896 11.024 12.4502C11.024 10.4092 8.501 9.88135 5.512 9.88135Z",
    fill: "#212B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.51202 7.93735C7.53673 7.93735 9.15928 6.17181 9.15928 3.96868C9.15928 1.76554 7.53673 0 5.51202 0C3.48804 0 1.86475 1.76554 1.86475 3.96868C1.86475 6.17181 3.48804 7.93735 5.51202 7.93735Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.6301 4.04085C10.6301 5.16278 10.3204 6.20965 9.77734 7.07925C9.72084 7.16868 9.77074 7.28926 9.86907 7.30842C10.0056 7.33318 10.1457 7.34835 10.2888 7.35154C11.7125 7.39227 12.9902 6.39491 13.3432 4.89288C13.8664 2.66419 12.3312 0.663086 10.3754 0.663086C10.1634 0.663086 9.96007 0.687042 9.76193 0.730961C9.73478 0.737349 9.70542 0.751722 9.69075 0.777275C9.67167 0.810015 9.68561 0.852337 9.70469 0.880285C10.2925 1.77703 10.6301 2.86862 10.6301 4.04085Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8343 10.1411C14.5738 9.53664 13.9449 9.1222 12.988 8.91858C12.5366 8.7988 11.314 8.62871 10.1773 8.65267C10.1604 8.65507 10.1509 8.66784 10.1494 8.67583C10.1472 8.6886 10.1523 8.70777 10.1743 8.72134C10.6998 9.00402 12.7304 10.2338 12.475 12.8274C12.464 12.9408 12.5469 13.0366 12.6504 13.0206C13.1501 12.9432 14.4359 12.6421 14.8343 11.7062C15.0552 11.2111 15.0552 10.6362 14.8343 10.1411Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon01);
export default __webpack_public_path__ + "static/media/menu-icon-01.061d27a3ed5a45fea6dc11e48e10582a.svg";
export { ForwardRef as ReactComponent };